module.exports = __webpack_public_path__ + "img/model1.281800aa.png";